export default "__VITE_ASSET__Beuyybyt__"